import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {CentroDeCustoDetail} from "./centro-de-custo-detail";

const CentroDeCustoDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/centrodecustos');
    }

    return (
        <CentroDeCustoDetail id={id} onClose={onClose}/>
    )

});

export default CentroDeCustoDetailPage;